const RECKON_ADMIN_EMAILS = Object.freeze([
  'kevinl@wereckon.com',
  'marcus.gunn@wereckon.com',
]);

function normalizeEmail(email) {
  return typeof email === 'string' ? email.trim().toLowerCase() : '';
}

function isReckonAdmin(user) {
  return Boolean(
    user?.emailVerified
      && RECKON_ADMIN_EMAILS.includes(normalizeEmail(user.email)),
  );
}

export {
  RECKON_ADMIN_EMAILS,
  isReckonAdmin,
  normalizeEmail,
};
